import UploadLimitsData from "../interfaces/UploadLimitsData";

export default function encodeUploadLimitsData(data: UploadLimitsData): string {
    return JSON.stringify({date: data.date.toISOString().split("T")[0], uploads: data.uploads});
}